import React from 'react';
import PropTypes from 'prop-types';
import { Formik, Field, Form } from 'formik';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import Input from '@hobs/components/Input';
import { H1, H2 } from '@hobs/components/Headings';
import Users from '../Users';
import Units from '../Units';
import {
  getParty,
  getPartyUnits,
  getAssignedPartyUnits
} from '../../actions/parties';
import './Party.scss';

class Party extends React.PureComponent {
  initialValues = {
    partyCode: '',
    title: '',
    requisitionNumber: ''
  };

  componentDidMount() {
    this.props.getParty();
    this.props.getPartyUnits();
    this.fetchAssignedUnits();
  }

  fetchAssignedUnits = () => {
    this.props.getAssignedPartyUnits();
  };

  render() {
    const { t, location, match, history } = this.props;

    return (
      <React.Fragment>
        <section>
          <H1>{t('Manage Party')}</H1>
          <div>
            <Formik
              enableReinitialize={true}
              initialValues={this.props.party || this.initialValues}
            >
              {({ setFieldValue }) => (
                <Form>
                  <div className="party-edit">
                    <H2>{t('Main details')}</H2>
                    <div className="party-edit--row">
                      <div className="party-edit--row--column">
                        <Field
                          name="partyCode"
                          setFieldValue={setFieldValue}
                          component={Input}
                          disabled={true}
                        >
                          {t('Code')}
                        </Field>
                      </div>
                      <div className="party-edit--row--column">
                        <Field
                          name="title"
                          setFieldValue={setFieldValue}
                          component={Input}
                          disabled={true}
                        >
                          {t('Title')}
                        </Field>
                      </div>
                      <div className="party-edit--row--column">
                        <Field
                          name="partyTypeLongName"
                          setFieldValue={setFieldValue}
                          component={Input}
                          disabled={true}
                        >
                          {t('Type')}
                        </Field>
                      </div>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </section>
        <section>
          <div className="party-component">
            <Units
              location={location}
              match={match}
              history={history}
              partyId={this.props.match.params.partyId}
              canEdit={this.props.party ? this.props.party.canEditUnits : false}
            />
          </div>
        </section>
        <section>
          <div className="party-component">
            <Users
              location={location}
              match={match}
              history={history}
              partyId={this.props.match.params.partyId}
              partyType={this.props.party ? this.props.party.partyTypeId : null}
              units={this.props.partyUnits}
              assignedUnits={this.props.assignedPartyUnits}
              onUserUpdated={this.fetchAssignedUnits}
            />
          </div>
        </section>
      </React.Fragment>
    );
  }
}

Party.propTypes = {
  t: PropTypes.func,
  location: PropTypes.object,
  match: PropTypes.object,
  history: PropTypes.object,
  party: PropTypes.object,
  partyUnits: PropTypes.array,
  getParty: PropTypes.func,
  updateParty: PropTypes.func,
  getPartyUnits: PropTypes.func,
  getAssignedPartyUnits: PropTypes.func,
  assignedPartyUnits: PropTypes.array
};

const mapStateToProps = state => ({
  party: state.parties.party,
  partyUnits: state.parties.partyUnits,
  auth: state.auth,
  assignedPartyUnits: state.parties.assignedPartyUnits
});

const mapDispatchToProps = {
  getParty,
  getPartyUnits,
  getAssignedPartyUnits
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withRouter(Party)));
